<template>
    <div class="wrap">
        <meeting_head></meeting_head>
        <router-view></router-view>
        <footer_index :ishowLink="false" :v-show="$route.meta.navShow"></footer_index>
    </div>
</template>

<script>
import meeting_head from './meeting_head';
// import footer_index from "./footer_index"
import footer_index from '../home/footer_index.vue';
export default {
    name: 'index',
    components: {
        meeting_head,
        footer_index
    }
};
</script>

<style scoped>
.wrap {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
